module.exports = __webpack_public_path__ + "static/media/3DIcon.51ab1929.png";